import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { BannerPositionsDataService, BannerPositionsColumnsService } from '../../../services';
import { BannerPosition, BannerPositionsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-banner-position-details',
  templateUrl: './banner-position-details.component.html',
  styleUrls: ['./banner-position-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerPositionDetailsComponent implements OnInit, OnDestroy {

  public bannerPosition: BannerPosition = {};
  public bannerPositions: BannerPosition[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannerPositionsDataService: BannerPositionsDataService,
    private bannerPositionsColumnsService: BannerPositionsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner Position - Details');
        this.getBannerPosition(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerPosition !== 'undefined') {
      this.bannerPosition = this.dynamicDialogConfig.data.bannerPosition;
    }
    this.columns = this.bannerPositionsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getBannerPosition(id: number): void {
    this.isLoading = true;
    this.bannerPositionsDataService.getBannerPosition(id).subscribe((response: BannerPosition|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerPosition = response;
      }
    });
  }

  list() {
    this.router.navigate(['/banner-positions']);
  }

  add() {
    this.router.navigate(['/banner-positions/add']);
  }

  edit() {
    this.router.navigate(['/banner-positions/edit/' + this.bannerPosition.id]);
  }

}
@Component({
  selector: 'app-banner-position-details',
  templateUrl: './banner-position-details.component.html',
  styleUrls: ['./banner-position-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerPositionDetailsComponent extends BannerPositionDetailsComponent {
}

